const token = () => window.localStorage.getItem('accessToken');

const request = async (path, method = 'GET', body) => {
  const resp = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token()}`
    },
    body: body === undefined ? undefined : JSON.stringify(body)
  });
  let json = null;
  try {
    json = await resp.json();
  } catch (err) {
    json = null;
  }
  if (!resp.ok || !json || json.status >= 400) {
    throw new Error(json?.message || `Erreur ${resp.status}`);
  }
  return json;
};

/** API de l'écran Paramètres > Rôles & permissions (php/App/Permission/RoleController.php). */
class RolesApi {
  async getRoles() {
    return (await request('/api/roles')).data;
  }

  async getUsers() {
    return (await request('/api/roles/users')).data;
  }

  async createRole(role) {
    return (await request('/api/roles/create', 'POST', role)).data;
  }

  async updateRole(role) {
    return (await request('/api/roles/update', 'POST', role)).data;
  }

  async deleteRole(id) {
    return request('/api/roles/delete', 'POST', { id });
  }

  async assignRole(userId, roleId) {
    return request('/api/roles/assign', 'POST', { user_id: userId, role_id: roleId });
  }
}

export const rolesApi = new RolesApi();

/** Profil historique (même logique que PermissionCatalog::legacyProfile côté PHP). */
export const legacyProfile = (accessLevel, idService) => {
  const al = Number(accessLevel);
  const sv = Number(idService);
  if (al === 0) {
    if (sv === 4) return 'admin_suivi';
    if (sv === 3) return 'admin_commercial';
    return 'admin';
  }
  if (sv === 3) return 'commercial';
  if (sv === 4) return 'suivi';
  return 'communication';
};

/**
 * Rôles proposables dans les écrans utilisateur, à partir de GET /api/roles.
 *
 * - Base migrée (`ready`) : les vrais rôles ; `value` = id du rôle, envoyé en role_id.
 * - Base pas encore migrée : les rôles que la migration créera ; `value` = code du
 *   profil, et seul le couple access_level / id_service est enregistré.
 */
export const toRoleOptions = (res) => {
  if (res.tablesReady) {
    return {
      ready: true,
      options: res.roles.map((r) => ({
        value: r.id,
        label: r.name,
        access_level: r.base_access_level,
        id_service: r.base_id_service
      }))
    };
  }
  return {
    ready: false,
    options: (res.preview || []).map((p) => {
      const profile = res.catalog.profiles.find((x) => x.code === p.code);
      return {
        value: p.code,
        label: p.name,
        access_level: profile ? profile.access_level : null,
        id_service: profile ? profile.id_service : null
      };
    })
  };
};

/** Valeur à présélectionner pour un utilisateur existant. */
export const currentRoleValue = (roleOptions, user) => {
  if (!roleOptions || !user) return '';
  if (roleOptions.ready) {
    return user.role_id !== null && user.role_id !== undefined && user.role_id !== '' ? Number(user.role_id) : '';
  }
  if (user.access_level === undefined || user.id_service === undefined) return '';
  return legacyProfile(user.access_level, user.id_service);
};
